import { X } from "lucide-react";

export default function ActiveFilters({ filters, price, onRemove, onClear }) {
  const activeItems = Object.entries(filters).flatMap(([group, values]) =>
    values.map((value) => ({ group, value }))
  );

  const hasPrice = price.min || price.max;

  if (!activeItems.length && !hasPrice) return null;

  return (
    <div className="flex flex-wrap items-center gap-2">
      {activeItems.map((item) => (
        <button
          key={`${item.group}-${item.value}`}
          type="button"
          onClick={() => onRemove(item.group, item.value)}
          className="inline-flex items-center gap-1 rounded-full bg-neutral-100 px-3 py-1.5 text-xs text-foreground"
        >
          {item.value}
          <X className="size-3" />
        </button>
      ))}

      {hasPrice && (
        <span className="rounded-full bg-neutral-100 px-3 py-1.5 text-xs">
          ৳{price.min || 0} - ৳{price.max || "Any"}
        </span>
      )}

      <button
        type="button"
        onClick={onClear}
        className="text-xs text-muted-foreground hover:text-foreground"
      >
        Clear all
      </button>
    </div>
  );
}